var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClient19(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 289.167,
    height: 44.878,
    viewBox: "0 0 289.167 44.878",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo19",
    transform: "translate(-1158.368 -5090.924)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    "data-name": "Path 362",
    d: "M1062.048-58.624h10.513l-21.323,38.86Zm-20.576,42.642-4.622-42.642h-11.482l28.256,43.675Z",
    transform: "translate(133 5150.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    "data-name": "Path 363",
    d: "M1117.957-37.76l14.016,21.781h-11.259Zm-14.166-21.894,11.706,1.03,2.46,20.864Zm-4.1,27.4H1118.4l-9.466,5.443Zm6.485-22.585L1094.4-15.98h-10.958Z",
    transform: "translate(133 5150.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    "data-name": "Path 364",
    d: "M1188.713-58.624h11.079l-5.539,20.691Zm5.54,20.691,5.892,21.951h-11.782Zm-36.991,19.057q-2.351-4.1-.595-11.376l1.894-7.68.77,5.331a21.247,21.247,0,0,0,2.595,7.853,12.277,12.277,0,0,0,5.086,4.757,16.909,16.909,0,0,0,7.677,1.6,24.372,24.372,0,0,0,8.624-1.6,27.69,27.69,0,0,0,6.874-3.555,25.394,25.394,0,0,1-5.3,4.071,34.371,34.371,0,0,1-7.783,3.353,32.2,32.2,0,0,1-9.363,1.346q-8.133,0-10.484-4.1m-4.31-39.748h11.71l-6.1,20.691Z",
    transform: "translate(133 5150.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    "data-name": "Path 365",
    d: "M1225.638-58.624h11.78l-6.113,20.691Zm5.667,20.691,6.262,21.951,21.1-9.456v9.456h-33.625Z",
    transform: "translate(133 5150.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    "data-name": "Path 366",
    d: "M1294.778-58.624l5.518,42.642h-10.959Zm-19.683,0h39.44v8.6l-19.757-8.6-19.683,8.6Z",
    transform: "translate(133 5150.578)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClient19);
export default __webpack_public_path__ + "static/media/client19.acf53a763bdc3dc89fc2ed2ca45d415a.svg";
export { ForwardRef as ReactComponent };